module.exports = __webpack_public_path__ + "img/choose-up-social.960cfa9c.png";